import { isUnsupportedByMorningstar } from './fund-info';
import { DASH_DEFAULT } from './Format/Format';

/**
 * derived from: https://bit.ly/31g0SW5
 */
export const convertArrayOfObjectsToCSV = (
    data,
    prependedContent,
    appendedContent,
    columnDelimiter = ',',
    lineDelimiter = '\n'
) => {
    if (!data.length) return '';
    const headers = Object.keys(data[0]);
    // filter morning star ratings to match screener values
    // possible US references are US74984 or US74982
    const filteredData = data.map((fundItem) =>
        Object.keys(fundItem).reduce(
            (acc, curr) => ({
                ...acc,
                [curr]:
                    curr.includes('Overall Morningstar Rating') &&
                    isUnsupportedByMorningstar(fundItem.Ticker)
                        ? DASH_DEFAULT
                        : fundItem[curr]
            }),
            {}
        )
    );

    let csvFileContent = prependedContent
        ? `${prependedContent}${lineDelimiter}`
        : '';

    const csvData = [
        headers,
        ...filteredData.map((row) => headers.map((header) => row[header]))
    ]
        .map((r) => r.join(columnDelimiter))
        .join(lineDelimiter);

    csvFileContent += csvData;

    if (appendedContent) {
        csvFileContent += `${lineDelimiter}${appendedContent}`;
    }

    return csvFileContent;
};

export const downloadCSV = (
    data,
    filename = 'export',
    prependedContent,
    appendedContent
) => {
    const csv = convertArrayOfObjectsToCSV(
        data,
        prependedContent,
        appendedContent
    );
    if (navigator.msSaveBlob) {
        // IE 10+
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        navigator.msSaveBlob(blob, `${filename}.csv`);
        return;
    }
    const uri = encodeURI(`data:text/csv;charset=utf-8,${csv}`);
    const link = document.createElement('a');
    link.setAttribute('href', uri);
    link.setAttribute('download', `${filename}.csv`);
    link.dispatchEvent(
        new MouseEvent(`click`, {
            bubbles: true,
            cancelable: true,
            view: window
        })
    );
    //    link.click();
};
